import i18n from 'i18next';
import I18NextHttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
export function initLocalization(appVersion, options) {
    return i18n
        .use(I18NextHttpBackend)
        .use(initReactI18next)
        .init({
        interpolation: {
            escapeValue: false,
        },
        returnObjects: true,
        ...options,
        backend: {
            queryStringParams: { v: appVersion },
            ...options.backend,
        },
    });
}
//# sourceMappingURL=init-localization.util.js.map